module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-22.7e28de69.png";